import React from "react";
import { makeStyles } from "@material-ui/core/styles";

//Importing Components

import style from "./style";

import { Grid, Typography, CardActionArea } from "@material-ui/core";
import { Link } from "react-router-dom";
import externalLink from "../../assets/social-icons/external-link.svg";
import github from "../../assets/social-icons/github2.svg";

const useStyles = makeStyles(style);

function Projects({ image, title, text, stack, githubLink, liveLink, id }) {
  const classes = useStyles();

  return (
    <Grid
      container
      direction="row-reverse"
      className={classes.section}
      spacing={2}
      style={{ alignContent: "center" }}
    >
      <Grid item xs={12} sm={6} data-aos="fade-in" className={classes.imageContainer}>
        <CardActionArea style={{ borderRadius: "8px" }}>
          <Link to={`/projects/${id}`} className="hover-detect">
            <img
              src={image}
              className={classes.categoriesIllustration}
              alt="Categories Illustration"
            />
          </Link>
        </CardActionArea>
      </Grid>
      <Grid item xs={12} sm={6} data-aos="fade-in" className={classes.categoriesSection}>
        <div>
          <Typography data-aos="fade-in" variant="h5">
            <Link
              className={`${classes.subtitle} ${classes.textAlignLeft} hover-detect`}
              to={`project/${id}`}
            >
              {title}
            </Link>
          </Typography>
          <div className={classes.content}>
            <Typography
              data-aos="fade-in"
              variant="h6"
              className={`${classes.description} ${classes.secondaryDesc} ${classes.textAlignLeft}`}
            >
              {text}
            </Typography>
          </div>
          <div className={classes.textAlignLeft} style={{ margin: "0rem" }}>
            {
              githubLink ? <a data-aos="fade-in" href={githubLink} className="hover-detect" target="_blank" rel="noreferrer">
                <Typography
                  data-aos="fade-in"
                  variant="h6"
                  className={`${classes.description} ${classes.links}`}
                >
                  Source Code
                  <img width={16} height={16} src={github} alt="github link"/>
                </Typography>
              </a> : <></>
            }
            {
              liveLink ? <a data-aos="fade-in" href={liveLink} className="hover-detect" target="_blank" rel="noreferrer">
                <Typography
                  data-aos="fade-in"
                  variant="h6"
                  className={`${classes.description} ${classes.links}`}
                >
                  Visit Project
                  <img width={16} height={16} src={externalLink} alt="external link"/>
                </Typography>
              </a> : <></>
            }

          </div>
        </div>
      </Grid>
    </Grid>
  );
}

export default Projects;
